export const settings: Pickadate.DateOptions = {
  monthsFull: [ 'януари','февруари','март','април','май','юни','юли','август','септември','октомври','ноември','декември' ],
  monthsShort: [ 'янр','фев','мар','апр','май','юни','юли','авг','сеп','окт','ное','дек' ],
  weekdaysFull: [ 'неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота' ],
  weekdaysShort: [ 'нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб' ],
  today: 'днес',
  clear: 'изтривам',
  close: 'затвори',
  firstDay: 1,
  format: 'd mmmm yyyy г.',
  formatSubmit: 'yyyy/mm/dd',
};
